module.exports = __webpack_public_path__ + "static/img/app3.2b26f1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app3.jpg
// module id = hQVc
// module chunks = 1